import { Component, OnInit  , AfterViewInit , Input} from '@angular/core';

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-scene-text',
  templateUrl: './scene-text.component.html',
  styleUrls: ['./scene-text.component.css']
})
export class SceneTextComponent implements OnInit , AfterViewInit{
    @Input() content:string;
    @Input() practiceIndex: number;
    @Input() picture: number;
    
  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit(){
      $("#scene_text_wrap").animate({opacity:1});

      // $("#scene_text_wrap").animate({marginTop:'0.3rem',opacity:1});
     $("#scene_text_wrap").html(this.content);
     $("#scene_text_wrap").find("img")[0].src = `../../assets/picture/casepractice/staff${this.picture}.png`;
     // $("#scene_text_wrap").find("p").css("marginTop","0.25rem");
     //  $("#scene_text_wrap").find("p").first().css("marginTop","0");
  }
}



// WEBPACK FOOTER //
// ./src/app/scene-text/scene-text.component.ts